module.exports = __webpack_public_path__ + "static/media/Travel.f210d8dc.svg";